






















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { CalendarItem } from '@/api'
import formatter from '@/helpers'

@Component
export default class FinanceCalendar extends Vue {
  @Prop() cal!: Array<CalendarItem>
  @Prop(String) name!: string
  @Prop(String) payType!: string

  formatDate (val: string | undefined): string {
    return formatter.formatDateNear(val)
  }

  filterType (): Array<CalendarItem> {
    const filtered: Array<CalendarItem> = []

    this.cal.forEach(val => {
      if (val.pay_type === this.payType) {
        filtered.push(val)
      }
    })

    return filtered
  }
}
